<div class="message-dilog">    
    <h2 mat-dialog-title>Information</h2>
     <mat-dialog-content>
      <p>{{ data.message }}</p>
     </mat-dialog-content>
     <mat-dialog-actions align="center">
       <button class="btn-red" mat-button (click)="dialogRef.close()">Close</button>
     </mat-dialog-actions>
</div>